<template>
    <span>
        <v-dialog max-width="600px">
             <span column slot="activator" class="fab-container">
            <v-btn icon class="mx-0" @click="edit(name)">
                      <v-icon color="teal">edit</v-icon>
           </v-btn>
           
        </span>
         <v-card
          flat
          class="flex"
         >
             <v-card-title primary-title>
                <h1 class="headline mb-1"><b>EDIT CAMPUS</b></h1>

             </v-card-title>
              
             <v-card-text class=" text-xs-center display-1  my-2 flex">
                
                Select a new name and image for this campus
             </v-card-text>
             <v-card-text>
                 <v-form class="px-3" ref="editform"> 
                     <v-text-field label="Name" v-model="nameloc"  @keypress="isName" :rules="nameRules" prepend-icon="folder"></v-text-field>
                     <v-icon>folder</v-icon> <span class="flex"><b>   Select Banner  </b> <input type="file" :class="nameloc"/></span>
                     <br/><span v-if="fileerror" class="red--text">You must select an image:png,jpeg or jpg</span>
                </v-form>
             </v-card-text>
             <v-divider></v-divider>
              <v-card-actions>
                <v-btn outline block color="brown" @click="add()" :disabled="isDisabled" :loading="isDisabled">Edit Campus</v-btn>
             </v-card-actions>
         </v-card>
        </v-dialog>
         <v-snackbar v-model="show" color="success">{{message}}</v-snackbar>
   
   </span>
</template>

<script>
import {editModuleWithAttachment,editCorrespend} from '@/model';
import moment from 'moment';

export default {
    name: 'EditCampus',
    props:{
        name :{
            required:true
        },
        movies:{
            required:true
        }
    },computed:{
            
            nameloc:{
                 
                get:function(){
                     return this.nameda;
                 },
                 set:function(name){
                      this.nameda = name
                 }
                 
                 
                 }
      
    },
    data() {
        return {
            isDisabled:false,
            nameda:this.name,
            fileerror:false,
            show:false,
            message:'',
            nameRules:[
               v => v.length >=3  || "Minimum length is 3 characters",
               v => v.length <=10  || "Maximum length is 10 characters",
               
           ],

        };
    },
    methods: {
        edit(name){
            console.log("Edit ",name);
            this.nameda = name;
            
        },
        isName:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if((charcode > 31 && (charcode < 48 || charcode > 57)) && charcode !== 46 && charcode !== 32){
                return true;
            }else{
                evt.preventDefault();
            }
        },
        add() {
            let self=this;
            if(this.$refs.editform.validate()){
            let datenow = moment().format('DD/MM/YYYY');
            let input = document.querySelector('.'+this.nameloc);
            let file = input.files[0];
            console.log(333);
            if(file){
                console.log(file.type);
            
              if((file.type !='image/jpeg') && (file.type !='image/png')){
                   this.fileerror = true;
                    return;
                }
                this.fileerror = false;
            }else{
                
                this.fileerror = true;
                return;
            }
            let useradd = this.$store.getters.getStaff.name;
            let newitem = {name:this.nameloc.toLowerCase(),movies:this.movies,file:file.type,dateadded:datenow,useredit:useradd};
            console.log(newitem);
            
            self.isDisabled = true;
            editModuleWithAttachment('campus',this.name,this.nameloc,newitem,file,function(response){
              if(response){
                  // module,mod_par_old,mod_par_new,cor_mod_par,fn
                    self.message = "This has been successfully updated";
                    self.show=true;
                    editCorrespend('staff',self.name,self.nameloc.toLowerCase(),'campus',function(res){
                    if(res){
                        if(self.name === self.$store.getters.getStaff.campus){
                             self.$store.commit('updateStaffAfterCorres', self.nameloc); 
                   
                         }
                    self.$store.dispatch('updateStaffs');
                    self.$store.dispatch('updateCampus',true);
                    self.isDisabled = false;
                    console.log(res);
                   
                        }
                    });
                    
                  }else{
                      console.log(null);
                      self.isDisabled = false;
                  }

              });

                          }
        }
    }
};
</script>

<style scoped>
</style>